import { useState } from "react";
import axios from "axios";
import { ROOT_URL, getAuthHeaders } from '../actions/constants';

const usePostRequest = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendRequest = async (postData) => {
    try {
      setLoading(true);
      const response = await axios.post(`${ROOT_URL}/${url}`, postData, getAuthHeaders());
      setData(response.data);
      setError(null);
    } catch (error) {
      setData(null);
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, sendRequest };
};

export default usePostRequest;